import React from 'react';
import {Navigate, useLocation, useParams} from 'react-router';

/** Redirect legacy `/whiteboards/*` paths to `/charts/*` (preserves path suffix, search, hash). */
export default function LegacyWhiteboardRedirect() {
    const {'*': rest} = useParams();
    const location = useLocation();
    const base = rest ? `/charts/${rest}` : '/charts';
    return <Navigate to={`${base}${location.search}${location.hash}`} replace/>;
}
